import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getZones = async () => {
    const zones = await axios.get('/service/zones')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching agences')
    })
    return zones.data
}